<footer>
  <div class="policies">
    <app-link
      i18n
      variant="white"
      href="https://www.agcocorp.com/int/en/home/privacy-center/cookie-policy/cookie-policy-en.html"
      >Cookie Policy</app-link
    >
    |
    <app-link
      i18n
      variant="white"
      href="https://www.agcocorp.com/int/en/home/privacy-center/privacy-statement/privacy-statement-en.html"
      >Privacy statement</app-link
    >
    |
    <app-language-selector />
  </div>
  <div i18n class="copyright">Copyright &copy; {{ currentYear }} AGCO Corporation. All Rights Reserved.</div>
  <div class="logo">
    <app-link variant="basic" href="https://www.agcocorp.com/">
      <img src="agco-logo-white.png" i18n-alt alt="AGCO logo" />
    </app-link>
  </div>
</footer>
